import { boolean, number, object, string, ZodIssueCode } from 'zod';
import type { RefinementCtx } from 'zod';

import { IS_REQUIRED, isGreaterThanOrEqualTo } from '@occc-app/lib/constants/validationMessages';

const requireLimitWhenEnabled = (
  data: { isEnabled: boolean; limit?: number },
  ctx: RefinementCtx,
) => {
  if (data.isEnabled && (data.limit === undefined || data.limit < 1)) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      path: ['limit'],
      message: data.limit === undefined ? IS_REQUIRED : isGreaterThanOrEqualTo(1),
    });
  }
};

export const progressPerTransactionLimitSchema = object({
  id: string().optional(),
  isEnabled: boolean(),
  limit: number().optional(),
}).superRefine(requireLimitWhenEnabled);
